import React, { HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

import './style.scss';

type Props = React.DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  active?: boolean
  className?: string
  children?: ReactNode
};

const SkeletonWrapper: React.FC<Props> = ({
  active, className, children, ...props
}) => (
  <div {...props} className={classNames('SkeletonWrapper', { 'SkeletonWrapper--active': active }, className)}>{ children }</div>
);

export default SkeletonWrapper;
